<template>
 <div class="details">
  <div class="container">
  
  <div v-if="$route.params.pageid === '1'">
 
 <div class="col-md-12" v-for="(product,index) in items1" :key="index">
     <div v-if="proId == product.id">
    <h4>{{product.category}} - {{product.type}}</h4>
     <h4>Series : {{product.series}} ; Size : {{product.size}}</h4>
     <h4>{{product.description}}</h4>
     <h4>Passages : {{product.passages}}</h4>
       <div v-if="!product.img1 == ''">
  <br>  <img :src="getPic(product.img1)" class="img-fluid" width="50%" v-bind:alt="pic"> 
       </div>
  
        <div v-if="!product.img2 == ''">
        <br> <img :src="getPic(product.img2)" class="img-fluid" width="50%" v-bind:alt="pic"> 
     </div>
 
       <div v-if="!product.img3 == ''">
    <br>     <img :src="getPic(product.img3)" class="img-fluid" width="50%" v-bind:alt="pic"> 
     </div>
 
       <div v-if="!product.img4 == ''">
    <br>  <img :src="getPic(product.img4)" class="img-fluid" width="50%" v-bind:alt="pic"> 
       </div>

     </div>
     </div>
    <div>
 </div>
    </div>
    
     <div v-if="$route.params.pageid === '2'">
 <div class="col-md-12" v-for="(product,index) in items2" :key="index">
     <div v-if="proId == product.id">
      <h4>{{product.category}} - {{product.type}}</h4>
     <h4>Series : {{product.series}} ; Size : {{product.size}}</h4>
     <h4>{{product.description}}</h4>
     <h4>Passages : {{product.passages}}</h4>
     <img :src="product.image" class="img-fluid">
            <div v-if="!product.img1 == ''">
  <br>  <img :src="getPic(product.img1)" class="img-fluid" width="50%" v-bind:alt="pic"> 
       </div>
  
        <div v-if="!product.img2 == ''">
        <br> <img :src="getPic(product.img2)" class="img-fluid" width="50%" v-bind:alt="pic"> 
     </div>
 
       <div v-if="!product.img3 == ''">
    <br>     <img :src="getPic(product.img3)" class="img-fluid" width="50%" v-bind:alt="pic"> 
     </div>
 
       <div v-if="!product.img4 == ''">
    <br>  <img :src="getPic(product.img4)" class="img-fluid" width="50%" v-bind:alt="pic"> 
       </div></div>
    </div>
    </div>


   <div v-if="$route.params.pageid === '3'">
 <div class="col-md-12" v-for="(product,index) in items3" :key="index">
     <div v-if="proId == product.id">
     <h4>{{product.category}} - {{product.type}}</h4>
     <h4>Series : {{product.series}} ; Size : {{product.size}}</h4>
     <h4>{{product.description}}</h4>
     <h4>Passages : {{product.passages}}</h4>
  <img :src="product.image" class="img-fluid">
            <div v-if="!product.img1 == ''">
  <br>  <img :src="getPic(product.img1)" class="img-fluid" width="50%" v-bind:alt="pic"> 
       </div>
  
        <div v-if="!product.img2 == ''">
        <br> <img :src="getPic(product.img2)" class="img-fluid" width="50%" v-bind:alt="pic"> 
     </div>
 
       <div v-if="!product.img3 == ''">
    <br>     <img :src="getPic(product.img3)" class="img-fluid" width="50%" v-bind:alt="pic"> 
     </div>
 
       <div v-if="!product.img4 == ''">
    <br>  <img :src="getPic(product.img4)" class="img-fluid" width="50%" v-bind:alt="pic"> 
       </div></div>
    </div>
    </div>

   <div v-if="$route.params.pageid === '4'">
 <div class="col-md-12" v-for="(product,index) in items4" :key="index">
     <div v-if="proId == product.id">
        <h4>{{product.category}} - {{product.type}}</h4>
     <h4>Series : {{product.series}} ; Size : {{product.size}}</h4>
     <h4>{{product.description}}</h4>
     <h4>Passages : {{product.passages}}</h4>
    <img :src="product.image" class="img-fluid">
          <div v-if="!product.img1 == ''">
  <br>  <img :src="getPic(product.img1)" class="img-fluid" width="50%" v-bind:alt="pic"> 
       </div>
  
        <div v-if="!product.img2 == ''">
        <br> <img :src="getPic(product.img2)" class="img-fluid" width="50%" v-bind:alt="pic"> 
     </div>
 
       <div v-if="!product.img3 == ''">
    <br>     <img :src="getPic(product.img3)" class="img-fluid" width="50%" v-bind:alt="pic"> 
     </div>
 
       <div v-if="!product.img4 == ''">
    <br>  <img :src="getPic(product.img4)" class="img-fluid" width="50%" v-bind:alt="pic"> 
       </div>  </div>
    </div>
    </div>

   <div v-if="$route.params.pageid === '5'">
 <div class="col-md-12" v-for="(product,index) in items5" :key="index">
     <div v-if="proId == product.id">
           <h4>{{product.category}} - {{product.type}}</h4>
     <h4>Series : {{product.series}} ; Size : {{product.size}}</h4>
     <h4>{{product.description}}</h4>
     <h4>Passages : {{product.passages}}</h4>
     
       <img :src="product.image" class="img-fluid">
            <div v-if="!product.img1 == ''">
  <br>  <img :src="getPic(product.img1)" class="img-fluid" width="50%" v-bind:alt="pic"> 
       </div>
  
        <div v-if="!product.img2 == ''">
        <br> <img :src="getPic(product.img2)" class="img-fluid" width="50%" v-bind:alt="pic"> 
     </div>
 
       <div v-if="!product.img3 == ''">
    <br>     <img :src="getPic(product.img3)" class="img-fluid" width="50%" v-bind:alt="pic"> 
     </div>
 
       <div v-if="!product.img4 == ''">
    <br>  <img :src="getPic(product.img4)" class="img-fluid" width="50%" v-bind:alt="pic"> 
       </div></div>
    </div>
    </div>
   <div v-if="$route.params.pageid === '6'">
 <div class="col-md-12" v-for="(product,index) in items6" :key="index">
     <div v-if="proId == product.id">
           <h4>Model : {{product.model}}</h4>
     <h5>Industry : {{product.industry}} </h5> 
    <h5> Application : {{product.application}}</h5>

    <div>
  <b-card>
    <b-card-text>
    {{product.description}}   </b-card-text>

   
  </b-card>
</div>
        <img :src="product.image" class="img-fluid">
            <div v-if="!product.img1 == ''">
  <br>  <img :src="getPic2(product.img1)" class="img-fluid" width="50%" v-bind:alt="pic"> 
       </div>
  
        <div v-if="!product.img2 == ''">
        <br> <img :src="getPic2(product.img2)" class="img-fluid" width="50%" v-bind:alt="pic"> 
     </div>
 
       <div v-if="!product.img3 == ''">
    <br>     <img :src="getPic2(product.img3)" class="img-fluid" width="50%" v-bind:alt="pic"> 
     </div>
 
       <div v-if="!product.img4 == ''">
    <br>  <img :src="getPic2(product.img4)" class="img-fluid" width="50%" v-bind:alt="pic"> 
       </div></div>
    </div>
    </div>


 <div v-if="$route.params.pageid === '7'">
 <div class="col-md-12" v-for="(product,index) in items7" :key="index">
     <div v-if="proId == product.id">
           <h4>Name : {{product.name}}</h4>
     <h5>Type : {{product.type}} </h5> 
    <h5> Series : {{product.series}}</h5>

    <div>
  <b-card>
    <b-card-text>
    {{product.description}}   </b-card-text>

   
  </b-card>
</div>
            <div v-if="!product.img1 == ''">
  <br>  <img :src="getPic3(product.img1)" class="img-fluid" width="40%" v-bind:alt="pic"> 
       </div>
  
        <div v-if="!product.img2 == ''">
        <br> <img :src="getPic3(product.img2)" class="img-fluid" width="40%" v-bind:alt="pic"> 
     </div>
 
       <div v-if="!product.img3 == ''">
    <br>     <img :src="getPic3(product.img3)" class="img-fluid" width="40%" v-bind:alt="pic"> 
     </div>
 
       <div v-if="!product.img4 == ''">
    <br>  <img :src="getPic3(product.img4)" class="img-fluid" width="40%" v-bind:alt="pic"> 
       </div>
        <div v-if="!product.description2 == ''">
      <br>
        <b-card>
    <b-card-text>
    {{product.description2}}   </b-card-text>

   
  </b-card>
        </div>
       </div>
       <br>
    </div>
    </div>

     </div>
 </div>
</template>
<script>

import productsData1 from '../products/ProductsData1'
import productsData2 from '../products/ProductsData2'
import productsData3 from '../products/ProductsData3'
import productsData4 from '../products/ProductsData4'
import productsData5 from '../products/ProductsData5'
import productsData6 from '../products/ProductsData6'
import productsData7 from '../products/ProductsData7'
 export default{
  name:'details',
  data(){
   return{
       items1: productsData1.filter((product) => product.id < 42),
    items2: productsData2.filter((product) => product.id < 42),
     items3: productsData3.filter((product) => product.id < 42),
     items4: productsData4.filter((product) => product.id < 42),
     items5: productsData5.filter((product) => product.id < 42),
     items6: productsData6.filter((product) => product.id < 42),
    items7: productsData7.filter((product) => product.id < 42),
   proId:this.$route.params.id,
    title:"details"
   }
  },
  methods: {
  getPic(index) {
    return 'img/rotating/' + index + '.jpg';
  }, 
  getPic2(index) {
    return 'img/slipring/' + index + '.jpg';
  }, 
  getPic3(index) {
    return 'img/barco/' + index + '.jpg';
  }
}
 }
</script>